import { render, staticRenderFns } from "./ResourceDownload.vue?vue&type=template&id=4407c4d9&scoped=true"
import script from "./ResourceDownload.vue?vue&type=script&lang=js"
export * from "./ResourceDownload.vue?vue&type=script&lang=js"
import style0 from "./ResourceDownload.vue?vue&type=style&index=0&id=4407c4d9&prod&lang=less&scoped=true"
import style1 from "./ResourceDownload.vue?vue&type=style&index=1&id=4407c4d9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4407c4d9",
  null
  
)

export default component.exports